import React, { Fragment } from 'react';
import DialogoPantallaCompleta from 'components/Dialogo/DialogoPantallaCompleta';
import PanelDePestania from 'components/Pestanias/PanelDePestania';
import DetalleDatosDelCanal from './DetalleDatosDelCanal';
import PestaniasDesplazables from 'components/Pestanias';
import TituloConIcono from 'components/tituloConIcono';
import { LibraryBooks } from '@mui/icons-material';
import DetalleDelTarifarioYDisponibilidad from './DetalleDelTarifarioYDisponibilidad';
import DetalleDeCobertura from './DetalleDeCobertura';

const dataTabs = [
    {label: "Datos del medio y demograficos", icon: <LibraryBooks />, position: 0},
    {label: "Tarifario y Disponibilidad", icon: <LibraryBooks />, position: 1},
    {label: "Cobertura", icon: <LibraryBooks />, position: 2},
];

const DetalleDelTarifario = ({title, openFullScreenDialog, handleClose, datosGeneralesDelTarifario, tipoDelMedio, mostrarDetalleDelCanal}) => {
    const [value, setValue] = React.useState(0);

    const handleChange = (_, newValue) => { setValue(newValue) };

    const closeFullScreenForm = function() { handleClose() }

    const {medioDeComunicacion: {tipoDeMedioDeComunicacion: {descripcion}}} = datosGeneralesDelTarifario;

    return (
        <DialogoPantallaCompleta
            openFullScreenDialog={openFullScreenDialog}
            handleClose={closeFullScreenForm}
            title={title}
            fullscreen={true}
            showButtonClose={false}
            showIconButton={true}
        >
            <Fragment>
                <TituloConIcono title={`Detalle del ${descripcion?.toLowerCase()} registrado`} mostrarTiempo={false} mostrarBotones={false} showDivider={false} icon="television" />
                <PestaniasDesplazables
                    handleChange={handleChange}
                    value={value}
                    tabs={dataTabs}
                >
                    <PanelDePestania value={value} index={0}>
                        <DetalleDatosDelCanal datosGeneralesDelTarifario={datosGeneralesDelTarifario} tipoDelMedio={tipoDelMedio} mostrarDetalleDelCanal={mostrarDetalleDelCanal} />
                    </PanelDePestania>
                    <PanelDePestania value={value} index={1}>
                        <DetalleDelTarifarioYDisponibilidad datosGeneralesDelTarifario={datosGeneralesDelTarifario} tipoDelMedio={tipoDelMedio} mostrarDetalleDelCanal={mostrarDetalleDelCanal} />
                    </PanelDePestania>
                    <PanelDePestania value={value} index={2}>
                        <DetalleDeCobertura datosGeneralesDelTarifario={datosGeneralesDelTarifario} tipoDelMedio={tipoDelMedio} mostrarDetalleDelCanal={mostrarDetalleDelCanal} />
                    </PanelDePestania>
                </PestaniasDesplazables>
            </Fragment>
        </DialogoPantallaCompleta>
    );
}

export default DetalleDelTarifario;